import React from "react";
import Store from "./store";
import AddStore from "./add-store";
import { history } from "../../store";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";

const StoreList = ({ stores, vouchers, fetched, dispatch, registration }) => {
  const onAddStoreClicked = () => {
    if (registration.pending && !registration.internal) {
      history.push("/registration/outlet");
    } else {
      dispatch({ type: "START_REGISTRATION_INTERNAL" });
      history.push("/outlet");
    }
  };

  let storeItems = <h1>Loading...</h1>;

  if (fetched) {

    storeItems = stores.map((store) => {

      return (
        <Store
          registration={registration}
          vouchers={vouchers}
          key={store.id}
          outlet={store}
        />
      );
    });
  }

  return (
    <div>
      <Col lg={12} className="stores--container">
        <div>{storeItems}</div>
        <div className="add-store-container">
          <AddStore
            key="-1"
            onAddStoreClicked={onAddStoreClicked}
            registration={registration}
            className="add-store--container"
          />
        </div>
      </Col>
    </div>
  );
};

export default connect()(StoreList);



// WEBPACK FOOTER //
// ./src/components/store-summary/store-list.jsx